import React, { Component } from 'react';
import { withRouter } from 'react-router';
import BillIcon from '../../../../Assets/General/BillIcon';
import CustomModal from '../../../../Components/CustomModal/CustomModal';
import ApplyOnInvoiceForm from '../../../../Components/Form/ApplyOnInvoiceForm/ApplyOnInvoiceForm';
import { NoItemsBox } from '../../../../Components/Layout/Box';
import ListTableColumnJoin from '../../../../Components/ListTable/ListTableColumnJoin';
import Loader from '../../../../Components/Loader/Loader';
import Table from '../../../../Components/Table/Table';
import getDate from '../../../../Helpers/Date/GetDate';
import { restRequest } from '../../../../Helpers/RequestHelper';
import { MdAdd } from '../../../../Common/Icons';
import DeleteIcon from '../../../../Assets/General/DeleteIcon';
import { getObjFromLS, setObjInLS } from '../../../../Helpers/LocalStorage';
import {
  NewBillIcon,
  NewInvoiceIcon,
} from '../../../../Assets/Navigation/NavigationIcons';
import InvoiceDetails from '../../../SalesOrder/Invoices/InvoiceDetails';
import { checkError } from '../../../../Helpers/AuthHelper';
import { t } from 'i18next';

class AppliedOnInvoiceTab extends Component {
  state = {
    loading: true,
    showApplyOnInvoice: false,
    applyInvoiceList: [],
    showDeleteInvoiceModal: false,
    viewApplyOnInvoiceModa: false,
    showButton: false,
    showPrompt: false,
    disable_apply_on_invoices_button: false,
  };
  componentDidMount() {
    this.fetchData();
  }

  handlePrompt = (status = true) => {
    this.setState({
      showPrompt: status,
    });
  };

  async fetchData() {
    await restRequest(
      'get',
      `creditnotes/${this.props.creditNoteId}/utilizaecredits`
    )
      .then((res) => {
        this.setState({
          showButton: res.show_button,
          applyInvoiceList: res.utilize_credits_list,
          loading: false,
          disable_apply_on_invoices_button:
            res.disable_apply_on_invoices_button,
        });
      })
      .catch((error) => {
        checkError(error);
        this.setState({ loading: false });
      });
  }

  openApplyOnInvoiceModal = () => {
    this.setState({
      showApplyOnInvoice: true,
    });
  };

  viewApplyOnInvoiceModal = (id) => {
    this.setState({
      viewApplyOnInvoiceModa: true,
      invoiceId: id,
    });
  };

  closeAllModals = () => {
    this.setState({
      showApplyOnInvoice: false,
      showDeleteInvoiceModal: false,
      viewApplyOnInvoiceModa: false,
    });
    document.title = t('Invoice.cn_detail');
  };

  renderViewInvoiceModal() {
    return (
      <CustomModal
        Icon={NewInvoiceIcon}
        showModal={this.state.viewApplyOnInvoiceModa}
        title={t('Invoice.view_invoice')}
        renderActions={false}
        size="large"
        className="popup-height"
        onClose={this.closeAllModals}
        linkTo={`invoices/${this.state.invoiceId}`}
      >
        <InvoiceDetails id={this.state.invoiceId} inModal={true} />
      </CustomModal>
    );
  }

  deletePaymentModal() {
    return (
      <CustomModal
        type="delete"
        showModal={this.state.showDeleteInvoiceModal}
        title={t('Invoice.confirm_delete_credits')}
        onClose={this.closeAllModals}
        onSubmit={this.deletePayment}
      >
        {t('Invoice.invoice_delete')}
      </CustomModal>
    );
  }

  deletePayment = () => {
    this.closeAllModals();
    restRequest('delete', `creditutilize/${this.state.clickedId}`)
      .then((res) => {
        let dataFromLS = getObjFromLS('module');
        if (dataFromLS === null) {
          let obj = {
            prevId: null,
            id: null,
            nextId: null,
            moduleName: '',
            urlPath: window.location.pathname,
            queryParam: window.location.search,
          };
          setObjInLS('module', obj);
          dataFromLS = getObjFromLS('module');
        }
        setObjInLS('module', {
          ...dataFromLS,
          queryParam: `${
            dataFromLS.queryParam ? dataFromLS.queryParam + '&' : '?'
          }appliedOnInvoices=true`,
        });
        this.fetchData();
        this.props.updateCreditNote();
        this.props.handleToast(t('Invoice.deleted_invoice'), 'success');
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
      });
  };
  renderApplyOnInvoiceModal() {
    const { creditNoteId, handleToast } = this.props;
    return (
      <CustomModal
        Icon={BillIcon}
        className="AppplyCredits"
        showModal={this.state.showApplyOnInvoice}
        title={`${t('Invoice.apply_credits')} | ${this.props.creditNoteNo}`}
        renderActions={false}
        size="large"
        onClose={this.closeAllModals}
        extraClass="apply_credit_notes" //commenting this to remove extra space from modal. Ticket related
        extraTitle={`${t('Invoice.total_available_credits')} : ${
          this.props.currency.symbol
        }${this.props.totalAvailableCredits}`}
        showPrompt={this.state.showPrompt}
      >
        <ApplyOnInvoiceForm
          inModal
          type="invoice"
          id={creditNoteId}
          handleToast={handleToast}
          onSubmit={this.handleRecordPaymentSubmit}
          onClose={this.closeAllModals}
          handlePrompt={this.handlePrompt}
        />
      </CustomModal>
    );
  }
  renderModals() {
    return (
      <>
        {this.renderApplyOnInvoiceModal()}
        {this.deletePaymentModal()}
        {this.renderViewInvoiceModal()}
      </>
    );
  }
  tableRowOptions = [
    {
      label: t('Invoice.actions.delete'),
      icon: DeleteIcon,
      onClick: (id) => this.openInvoiceDeleteModal(id),
      disabled: () => !this.props.hasPermissionCustom('creditnotes', 'Delete'),
    },
  ];

  openInvoiceDeleteModal = (id) => {
    this.setState({
      showDeleteInvoiceModal: true,
      clickedId: id,
    });
  };

  prepareApplyInvoiceList(data) {
    return data.map((invList) => {
      return {
        ...invList,
        paymentDate: getDate(invList.credit_utilize_date),
        no: this.props.inModal ? (
          invList.invoice.invoice_no
        ) : (
          <ListTableColumnJoin
            column1={
              <div
                className="payment_view"
                onClick={() => this.viewApplyOnInvoiceModal(invList.invoice_id)}
              >
                {invList.invoice.invoice_no}
              </div>
            }
          />
        ),
        amount_credited: `${this.props.currency.symbol}${invList.used_credits}`,
      };
    });
  }

  renderApplyInvoiceTableData() {
    const tableListData = this.prepareApplyInvoiceList(
      this.state.applyInvoiceList
    );
    const tableHeaders = [
      t('Invoice.date_credits'),
      t('Invoice.invoice_no'),
      t('Invoice.amount_credited'),
    ];
    const tableData = [
      'paymentDate',
      'no',
      'amount_credited',
      !this.props.inModal && 'options',
    ];

    return (
      <>
        {this.state.applyInvoiceList.length > 0 && (
          <div className="float-left w-100">
            <Table
              list={tableListData}
              tableHeaders={tableHeaders}
              tableData={tableData}
              fromTab={true}
              options={this.props.inModal ? [] : this.tableRowOptions}
              className={`box-table ${
                this.props.label ? this.props.label + '_menu' : ''
              }`}
            />
          </div>
        )}
        {this.state.showButton &&
          this.props.hasPermissionCustom('creditnotes', 'Create') &&
          (this.props.inModal ? (
            ''
          ) : (
            <button
              className="layout-box--button btn-width"
              onClick={this.openApplyOnInvoiceModal}
            >
              <MdAdd className=" black-fill" />
              {t('Invoice.apply_to_invoice')}
            </button>
          ))}
      </>
    );
  }
  ApplyOnInvoiceList() {
    return (
      <>
        {this.renderModals()}
        {!this.state.applyInvoiceList.length ? (
          <NoItemsBox
            subtitle={
              t('Invoice.credit_not_available')
              // this.state.showButton ? '' : t('Invoice.credit_not_available')
            }
            buttonText={t('Invoice.apply_to_invoice')}
            showButton={this.state.showButton}
            handleclick={this.openApplyOnInvoiceModal}
            handleclickSecondary={this.openApplyCreditsPaymentModal}
            Icon={NewBillIcon}
            inModal={this.props.inModal}
            btnDisabled={this.state.disable_apply_on_invoices_button}
          />
        ) : (
          this.renderApplyInvoiceTableData()
        )}
      </>
    );
  }

  render() {
    //console.log('this.state', this.state);
    if (this.state.loading) return <Loader />;
    return this.ApplyOnInvoiceList();
  }
}
export default withRouter(AppliedOnInvoiceTab);
